import { debounce, get } from "lodash";
import { useEffect } from "react";

import {
  CurriculumLevelStatus,
  useGetLevelsLazyQuery,
} from "~/schemas/generated/graphql";

export const useGetAllLevelsForSelect = () => {
  const [getLevels, { data, loading, fetchMore }] = useGetLevelsLazyQuery({
    variables: {
      page: 0,
      count: 25,
      status: CurriculumLevelStatus.Active,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    getLevels();
  }, []);

  const levels = data?.EducationGetter?.getListLevelCurriculum?.items.map(
    ({ id, name }) => {
      return {
        value: id,
        label: `${name}`,
      };
    },
  );

  const intersectionObserver = () => {
    if (levels.length < 25) {
      return;
    }
    const page = Math.ceil(levels.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },
      updateQuery: ({ EducationGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { EducationGetter };
        }
        return {
          EducationGetter: {
            ...EducationGetter,
            getListLevelCurriculum: {
              ...EducationGetter.getListLevelCurriculum,
              items: [
                ...EducationGetter.getListLevelCurriculum.items,
                ...get(
                  fetchMoreResult,
                  "EducationGetter.getListLevelCurriculum.items",
                  [],
                ),
              ],
            },
          },
        };
      },
    });
  };

  const searchText = debounce((searchText: string) => {
    getLevels({
      variables: {
        page: 0,
        name: searchText || null,
      },
    });
  });

  return {
    levels,
    intersectionObserver,
    searchText,
    loading,
  };
};
